import { render } from "./StatsBuilderSubColItem.vue?vue&type=template&id=2aecc28d"
import script from "./StatsBuilderSubColItem.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderSubColItem.vue?vue&type=script&lang=ts"

import "./StatsBuilderSubColItem.vue?vue&type=style&index=0&id=2aecc28d&lang=scss"
script.render = render

export default script